import { Box, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { FORTA_BLUE } from '../../utils/colors';

interface FHSideDrawerProps {
  open: boolean;
  children: any;
  sx?: any;
  titleStyles?: any;
  title?: string;
  anchor?: 'top' | 'left' | 'bottom' | 'right';
  onClose: () => void;
}

const defaultStyles = {
  px: 3,
  pb: 3,
  backgroundColor: FORTA_BLUE.light3,
};

function FHSideDrawer({
  sx = {},
  titleStyles = {},
  open,
  title = '',
  children,
  anchor = 'right',
  onClose,
}: FHSideDrawerProps) {
  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      sx={{ '& .MuiDrawer-paper': { ...defaultStyles, ...sx } }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography sx={{ fontSize: 24, color: FORTA_BLUE.dark, py: 2, ...titleStyles }}>
          {title}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      {children}
    </Drawer>
  );
}

export default FHSideDrawer;
